import React from 'react'
import { Routes, Route } from "react-router-dom";
import Home from "../routes/home";
import About from "../routes/about"
import Team from "../routes/team"
import Dashboard from "../routes/dashboard"

const BodyContent = () => {
  return (
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About/>} />
        <Route path="/team" element={<Team />} />
        <Route path="/dashboard" element={<Dashboard />} />
    </Routes>
  )
}

export default BodyContent